import { PaginatedRequestParams } from '../../api/nm-types'
import { FilterBy, FilterTemplate } from '../common/Filters/FilterView/FilterTemplate'

export enum ListAddressMappingFilterKey {
  search = 'search phrase',
}

export function mapAddressMappingFilterToUrlParam(filter: FilterBy): Partial<PaginatedRequestParams> {
  if ('value' in filter) {
    switch (filter.key) {
      case ListAddressMappingFilterKey.search:
        return { filter: filter.value }
    }
  }
  return {}
}

export function mapUrlParamToAddressMappingFilter(
  key: keyof PaginatedRequestParams,
  value: string,
): FilterBy | undefined {
  switch (key) {
    case 'filter':
      return {
        key: ListAddressMappingFilterKey.search,
        operator: 'matches',
        value,
      }
  }
  return undefined
}

export function makeListAddressMappingsFilter(): FilterTemplate[] {
  const filterTemplates: FilterTemplate[] = [{ key: ListAddressMappingFilterKey.search, operator: 'matches' }]
  return filterTemplates.sort((a, b) => a.key.localeCompare(b.key))
}
